import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function ProtectedEditRoute({ children, token, authLoading }) {
    const { userId: currentUserId, decodedUser } = useAuth();

    if (authLoading) {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-orange-500" />
            </div>
        );
    }

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (!currentUserId) {
        return <Navigate to="/" replace />;
    }

    if (decodedUser?.type === 'partner') {
        return <Navigate to="/" replace />;
    }

    return children;
}
